module.exports = __webpack_public_path__ + "img/logo.09594430.png";